import React from "react";

import Color from "../Color";
import arrayIdFinder from "../helpers/arrayIdFinder";

function initials(name) {
  return name
    .split(" ")
    .map(a => a[0])
    .join("");
}

function EmployeeIcon({ employee }) {
  return (
    <g>
      <circle
        cx={0}
        cy={0}
        r={25}
        stroke={Color.initial}
        strokeWidth="1"
        fill={Color.gradientMid}
      />
      <text x={0} y={6} textAnchor="middle" fontSize={16} fill={Color.initial}>
        {employee && initials(employee.name)}
      </text>
    </g>
  );
}

function EmployeeIcons({ employees, employeeDetails, lineManagerDetails }) {
  const nEmployees = employees ? employees.length : 0;
  if (nEmployees === 0) return null;
  let firstEmployee =
    lineManagerDetails || employees[0];
  return (
    <g>
      {nEmployees > 2 && (
        <g transform="translate(30,0)">
          <EmployeeIcon />
        </g>
      )}
      {nEmployees > 1 && (
        <g transform="translate(15,0)">
          <EmployeeIcon />
        </g>
      )}
      <EmployeeIcon employee={firstEmployee} />
    </g>
  );
}

export default EmployeeIcons;
